import React from 'react';
import styledTheme from 'common/theme';
import styled from 'styled-components';

interface SwatchProps {
  color: string;
  onClick?: (color: string) => void;
  fieldName?: string;
  disabled?: boolean;
}

interface SwatchContainerProps {
  color: string;
}

const SwatchContainer = styled.div<SwatchContainerProps>`
  background-color: ${({ color }) => color};
  width: 24px;
  height: 24px;
  display: inline-block;
  margin: 5px;
  border-radius: 50%;
`;

const SwatchContBtn = styled.button<SwatchContainerProps & { disabled?: boolean }>`
  background-color: ${({ color }) => color};
  height: 15px;
  display: inline-block;
  margin: 5px 3px;
  border-radius: 3px;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.15);
  border: 0.5px solid ${styledTheme.colors.gray300};
  margin: 0;
  padding: 0;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed !important' : 'pointer')};
  pointer-events: ${({ disabled }) => (disabled ? 'all' : 'auto')};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
`;

export const Swatch = ({ color, onClick, fieldName }: SwatchProps): JSX.Element => {
  return (
    <SwatchContainer
      data-value={color}
      data-field-name={fieldName}
      color={color}
      onClick={() => onClick?.(color)}
    />
  );
};

export const SwatchButton = ({ color, onClick, disabled }: SwatchProps): JSX.Element => {
  return (
    <SwatchContBtn
      className="swatch-list"
      color={color}
      onClick={() => onClick?.(color)}
      disabled={disabled}
    ></SwatchContBtn>
  );
};
